<template>
  <div class="feixe_outros" style="display: none;">
    <div class="row">
      <h5 class="disparador" data-disparador="conteudo_outros">
        (se for se for outros)
        <i class="material-icons">arrow_drop_down</i>
      </h5>
    </div>
    <div class="conteudo" id="conteudo_outros" style="display: none;">
      <div class="form-group">
        <label for="exampleInputEmail1">Formato:</label>
        <select class="form-control" id="input_type">
          <option>Python</option>
          <option>Matlab</option>
          <option>MTX</option>
        </select>
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <div class="custom-file">
          <input type="file" class="form-control custom-file-input" id="customFile" />
          <label class="custom-file-label" for="customFile">Escolher arquivo</label>
        </div>
      </div>
      <div class="form-group">
        <label for="exampleFormControlTextarea1">Insira o código manualmente</label>
        <textarea class="form-control form-cotrol-sm" id="exampleFormControlTextarea1" rows="3"></textarea>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name:'outros'
}
</script>